// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3WD7l","colMaxWidth":"Table_colMaxWidth__13BAE"};